import { render, staticRenderFns } from "./FormInputRadioOptions.vue?vue&type=template&id=b2f64170"
import script from "./FormInputRadioOptions.vue?vue&type=script&lang=js"
export * from "./FormInputRadioOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports